import React from 'react';


export const WordPress = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/wordpress.png')} />
    )
};
